import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Portal } from '@material-ui/core';

import { AppMainNotificationProps } from './AppMainNotification.interface';
import { Notification } from 'app/components/Notification';
import { NotificationActions } from 'app/store/data/notification';
import { RootState } from 'app/store/rootReducer';
import { useStyles } from './AppMainNotification.styles';

function AppMainNotification(props: AppMainNotificationProps) {
  const classes = useStyles();
  const dispatch = useDispatch();
  const notification = useSelector((state: RootState) => state.notification);
  const hideNotification = () =>
    dispatch(NotificationActions.hideNotification());

  return (
    <Portal container={document.body}>
      <div className={classes.portalRoot}>
        <div className={classes.notificationWrapper}>
          <Notification
            open={notification.isVisible}
            type={notification.type}
            content={notification.content}
            onClose={hideNotification}
          />
        </div>
      </div>
    </Portal>
  );
}

export default AppMainNotification;
